/** Clinical-task link type for the Work project Heidi used on this task. */
export const CLINICAL_TASK_WORK_PROJECT_LINK_TYPE = 'WORK_PROJECT' as const;

type ClinicalTaskWorkProjectLink = {
  type?: string | null;
  id?: string | null;
};

type LinkedTask = {
  id?: string | null;
  links?: ReadonlyArray<ClinicalTaskWorkProjectLink> | null;
};

const isWorkProjectLinkType = (type?: string | null): boolean =>
  type === CLINICAL_TASK_WORK_PROJECT_LINK_TYPE;

export const getDelegatedWorkProjectId = (
  task: LinkedTask | null | undefined
): string | null => {
  const id = task?.links?.find((link) => isWorkProjectLinkType(link.type) && link.id)?.id;
  return id ?? null;
};

export const withTaskDelegatedToHeidi = <T extends LinkedTask>(
  task: T,
  taskId: string,
  projectId: string
): T => {
  if (task.id !== taskId) return task;
  const links = task.links ?? [];
  if (links.some((link) => isWorkProjectLinkType(link.type) && link.id === projectId)) {
    return task;
  }
  return {
    ...task,
    links: [...links, { type: CLINICAL_TASK_WORK_PROJECT_LINK_TYPE, id: projectId }],
  };
};
